import React, { useEffect, useState } from 'react'

import WithDetailedBoardLayout from './WithDetailedBoardLayout'
import PlayerPanelDashboard from './PlayerPanelDashboard'
import FullGameDashboard from './FullGameDashboard'

import ObsStateDisplay from './ObsStateDisplay'

import { useStore } from '../../zustandStore'
import { shallow } from 'zustand/shallow'

const CtrlPanelPage = (props) => {
  const {
    isFullGame,
    obsState,
    unstageObsState,
    isLoading,
    setIsLoading,
    setHasSentUpdate
  } = useStore(
    state => ({
      isFullGame: state.event.isFullGame,
      obsState: state.obsState,
      unstageObsState: state.unstageObsState,
      isLoading: state.isLoading,
      setIsLoading: state.setIsLoading,
      setHasSentUpdate: state.setHasSentUpdate
    }),
    shallow
  )

  const [sortingByChapterName, setSortingByChapterName] = useState(obsState.currentChapterName)

  const sendWebSocketMessage = (message) => {
    if (!isLoading) {
      window.obsSubscription.send(message)
      setIsLoading(true)
      setHasSentUpdate(true)
    }
  }

  const pushPlayerToBroadcast = (playerSlug) => {
    sendWebSocketMessage({
      type: 'set_to_player_source',
      current_player_slug: playerSlug
    })
  }

  const pushLeaderboardToBroadcast = ({chapterName, page}) => {
    sendWebSocketMessage({
      type: 'set_to_leaderboard_source',
      current_chapter_name: chapterName,
      current_page: page
    })
  }

  const pushSubmissionsFeedToBroadcast = () => {
    sendWebSocketMessage({
      type: 'set_to_submissions_source'
    })
  }

  const pushBracketsToBroadcast = () => {
    sendWebSocketMessage({
      type: 'set_to_brackets_source'
    })
  }

  useEffect(() => {
    if (obsState.currentSourceType == 'leaderboard') {
      setSortingByChapterName(obsState.currentChapterName)
    }
  }, [obsState.currentChapterName])

  useEffect(() => {
    unstageObsState()
  }, [obsState.currentScene])

  return (
    isFullGame ? (<>
      {/* <ObsStateDisplay/> */}
      <FullGameDashboard
        pushPlayerToBroadcast={pushPlayerToBroadcast}
        pushLeaderboardToBroadcast={pushLeaderboardToBroadcast}
        pushSubmissionsFeedToBroadcast={pushSubmissionsFeedToBroadcast}
        pushBracketsToBroadcast={pushBracketsToBroadcast}
      />
    </>
    ) : (
      <WithDetailedBoardLayout
        setSortingByChapterName={setSortingByChapterName}
        sortingByChapterName={sortingByChapterName}
        pushPlayerToBroadcast={pushPlayerToBroadcast}
      >
        <PlayerPanelDashboard
          pushPlayerToBroadcast={pushPlayerToBroadcast}
          pushLeaderboardToBroadcast={pushLeaderboardToBroadcast}
          pushSubmissionsFeedToBroadcast={pushSubmissionsFeedToBroadcast}
          pushBracketsToBroadcast={pushBracketsToBroadcast}
        />
      </WithDetailedBoardLayout>
    )
  )
}

export default CtrlPanelPage
